<template>
    <div class="fakeddcontainer cursor-pointer">
        <p class="fakedd" @click.stop="disabled ? null : (dd_open ? dd_open = false : dd_open = true)" :class="{'disabled':disabled}" style="padding:0.5rem 1rem;font-size:1.1rem;"> {{localState ? localValue : value}}
            <i :class="!dd_open ? 'rot0' : 'rot180'" class="fa fa-angle-down pull-right" style="line-height: 2rem; color:#e90054"></i>
        </p>
        <transition name="slide-fade">
            <div v-if="dd_open" class="ddfake-open">
                <p v-for="t, index in options" class="ddfake-opt" @click="select(index,t)">{{property ? options[index][property] : options[index]}}</p>
            </div>
        </transition>
    </div>
</template>
<script>
export default {
  props: ["options", "value", "disabled", "property", "localState"],
  data() {
    return {
      localValue: "Selecione",
      selected: null,
      dd_open: false
    };
  },
  methods: {
    select(index, t) {
      this.selected = index;
      this.dd_open = false;
      this.$emit("selected", [index, this.options[index], t]);

      if (this.localState) {
        this.localValue = this.property
          ? this.options[index][this.property]
          : this.options[index];
      }
    }
  }
};
</script>
<style scoped lang="scss">
.fakeddcontainer {
  position: relative;
}

.fakedd {
  position: relative;
  //margin: 1.5rem 0 0;
  line-height: 2rem;
  padding: 0 0.5rem;
  font-size: 0.8rem;
  min-height: 2rem;
  width: 100%;
  border: solid 1px #dedede;
  //border-radius: 3px;
  //color: black;
  //font-size: 1rem;
}

.ddfake-open {
  max-height: 12rem;
  overflow-y: auto;
  background-color: white;
  position: absolute;
  top: 3rem;
  z-index: 2;
  width: 100%;
  border: solid 1px #dedede;
  border-radius: 3px;
}

.ddfake-opt {
  font-size: 1.1rem;
  color: black;
  line-height: 3rem;
  z-index: 3;
  cursor: pointer;
  padding: 0 0.5rem;
}

.ddfake-opt:hover {
  color: white;
  background-color: #2d3256;
}

.disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/FakeDd.vue